import { useEffect } from 'react';

import { useIsBodyFontRefreshEnabled } from '@/app-shell/flags/body-font-refresh-flag';

const MARKER_CLASS = 'body-font-refresh';

/**
 * Adds the `body-font-refresh` marker class to <html> while the
 * release-body-font-refresh flag is on, so the General Sans body font + refreshed
 * weight/letter-spacing (globals.css) apply app-wide, including Radix portals
 * outside <main>.
 *
 * Client-resolved flag ⇒ a flagged-on session briefly paints Inter before the
 * class lands (FOUC). Invisible while the flag is off; a pre-rollout gate once it's
 * flipped on — remediation path in docs/body-font-refresh.md ("Before you roll
 * out"). Must be mounted inside OpenFeatureProvider.
 */
export function BodyFontRefreshMarker() {
  const isEnabled = useIsBodyFontRefreshEnabled();

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle(MARKER_CLASS, isEnabled);
    return () => root.classList.remove(MARKER_CLASS);
  }, [isEnabled]);

  return null;
}
